import React from "react";
import {
    TextField,
    Autocomplete,
 
} from "@mui/material";

const RCMTeamsDropdown = ({
    classes=undefined,
    tempRcmTeam=undefined,
    currentRcmTeamName=undefined,
    handleStatusChange,
    rcmAssignmentData,
}) => {
    return (
        <Autocomplete
            disableClearable
            className={classes?.autoComplete}
            value={
                tempRcmTeam || {
                    name: currentRcmTeamName || "Unassigned",
                }
            }
            onChange={(e, option) => {
                handleStatusChange(option);
            }}
            isOptionEqualToValue={(option, value) => {
                return option?.name === value?.name || option?.name === value;
            }}
            options={rcmAssignmentData || []}
            getOptionLabel={(option: any) => option?.name || option}
            renderInput={(params) => (
                <TextField
                    {...params}
                    required
                    name={`Rcm Assignment`}
                    label="Rcm Teams"
                    margin="normal"
                />
            )}
        />
    );
};

export default RCMTeamsDropdown;
